export interface ResetPasswordRequestModel {
  email: string;
  password: string;
  code: string;
}
